var KNOWLEDGE_BASE_API_CONFIG = {
    baseUrl: '',
    marketLocale: '',
};
export var getKnowledgeBaseApiConfig = function () {
    return KNOWLEDGE_BASE_API_CONFIG;
};
export var setKnowledgeBaseApiConfig = function (config) {
    KNOWLEDGE_BASE_API_CONFIG.baseUrl = config.baseUrl;
    KNOWLEDGE_BASE_API_CONFIG.marketLocale = config.marketLocale;
    KNOWLEDGE_BASE_API_CONFIG.headers = config.headers;
};
